<template>
  <div>
    <div class="text-center mt-2" v-if="$store.getters['dash/externalPlatforms'][platform].noReviews === false && !$store.getters['dash/externalPlatforms'][platform].error">
      <div class="block max-w-sm mx-auto mt-10">
        <div class="w-8 h-8 pt_loading inline-block"></div>
        <p class="text-dark max-w-sm text-lg mx-auto">Fetching reviews! Importing reviews depends on the profile type and review count, and may take anything from 1min. up to an hour.</p>
    </div>
    </div>
    <div v-else>
    <div v-if="$store.getters['dash/externalPlatforms'][platform].error">
      <div class="block max-w-md mx-auto mt-10">
        <div class="my-2 flex items-center text-lg">
          <feather-icon icon="InfoIcon" svgClasses="stroke-current w-6 h-6" class="mx-2" />
          <span class="inline-block max-w-lg">We've had some issues getting your reviews. Ensure that your <a href="" @click.prevent="$router.push('/dash/settings/sharingandreviews')">profile address</a> is correct, or <a href="" @click.prevent="chatToUs">get help</a>.</span>
        </div>
      </div>
    </div>
    <div v-else>    
    <div v-if="$store.state.dash.viewData.reviews[platform].reviews.length === 0 && !$store.state.dash.viewData.reviews[platform].loading">
      <div class="block max-w-md mx-auto mt-10">
        <div class="my-2 flex items-center text-lg">
          <feather-icon icon="InfoIcon" svgClasses="stroke-current w-6 h-6" class="mx-2" />
          <span class="inline-block max-w-lg">It looks like you don't have any reviews. If you think this is a mistake, try refreshing the browser window, or <a href="" @click.prevent="chatToUs">get help</a>.</span>
        </div>
      </div>
    </div>
    <div class="vx-row w-full mx-0">
      <div class="vx-col px-2 flex mb-base w-full md:w-1/2 lg:w-1/2 2xl:w-1/3" v-for="(review, i) in $store.state.dash.viewData.reviews[platform].reviews">
        <vx-card class="w-full text-dark botcontrolscard relative nohover" :class="{'pt_ple_shadow': currentShowcaseIDs.includes(review.unique_id)}">
          <div class="vx-row">
            <div class="vx-col w-1/2">
          <div>
            <vue-load-image v-if="review.profile_picture" >
              <div slot="preloader" style="border-radius: 50%;" class="profiledown w-8 float-left mr-3">
                <feather-icon  icon="StarIcon" svgClasses="w-10 h-10 text-primary"></feather-icon>
              </div>
              <img slot="image" style="border-radius: 50%;" :src="review.profile_picture" class="profiledown w-10 float-left"/>
              <div slot="error" style="border-radius: 50%;" class="profiledown w-8 float-left mr-3">
                <feather-icon  icon="StarIcon" svgClasses="w-10 h-10 text-primary"></feather-icon>
              </div>
            </vue-load-image>
            <div v-else style="border-radius: 50%;" class="profiledown w-8 float-left mr-3">
              <feather-icon  icon="UserIcon" svgClasses="w-10 h-10 text-primary"></feather-icon>
            </div>
            <p class="font-semibold">{{ typeof review.name === 'string' ? review.name.substr(0,15) : ''}}</p>
            <p>{{ review.date }}</p>
          </div>
        </div>
        <div class="vx-col w-1/2 text-right">
          <star-rating v-if="review.rating_value" class="my-1 inline-block" :rating="review.rating_value" :star-size="20" :read-only="true" :round-start-rating="false"></star-rating>
        </div>
      </div>
        <vs-divider/>
          <p v-if="review.review_title !== null" class="font-semibold" :class="{'mb-4': platform === 'ca'}">{{ review.review_title.substr(0, 30) }}{{review.review_title.length > 30 ? '...' : ''}}</p>
          <p v-if="review.review_text"><span class="text-xl font-bold italic inline-block mx-1" v-if="platform !== 'ca'">"</span><span class="" v-html="review.review_text"></span><span class="text-xl font-bold italic inline-block mx-1" v-if="platform !== 'ca'">"</span></p>
          <p class="text-light" v-else>(No review text provided)</p>
          <div class="botcontrols px-2 py-2">
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <Showcase 
                  size="base" 
                  class="ml-3" 
                  :payload="{
                    data: { 
                      platform: platform, 
                      i:i, 
                      reviewDocID: review.unique_id 
                    }, 
                    method: toggleShowcaseReview 
                  }"                   
                  :showcasedStatus="currentShowcaseIDs.find(sItem => String(sItem.id) === String(review.unique_id))" 
                  />

              </div>
              <div class="vx-col w-1/2 text-right">
                <vs-button :href="review.url" target="_blank" class="float-right px-3" color="primary" type="flat" icon-pack="feather" icon="icon-chevron-right" icon-after>View/Reply</vs-button>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <vs-button @click="getMore" class="w-full" v-if="($store.state.dash.viewData.reviews[platform].reviews.length === $store.state.dash.viewData.reviews[platform].currentThreshold - 50) && !$store.state.dash.viewData.reviews[platform].loading" type="border">Load More</vs-button>
    <div class="py-20" v-if="$store.state.dash.viewData.reviews[platform].loading">
      <div class="text-center mt-2">
        <div class="w-12 h-12 pt_loading inline-block"></div>
        <p class="text-light max-w-xxs mx-auto">Loading reviews...</p>
      </div>
    </div>
  </div>
</div>
</div>
</template>


<script>

import VueLoadImage from 'vue-load-image'
import StarRating from 'vue-star-rating'
import Showcase from './Showcase.vue'
// es5
//var VueLoadImage = require('vue-load-image').default


export default {
  data() {
    return {
      refreshClicked: false
    }
  },
  props: {
    platform: String,
  },
  watch: {
    noReviews (newV, oldV) {
      if (newV !== false && oldV === false) {
        //initial loading has taken place, load possible reviews
        this.getMore()
      }
    }
  },
  computed: {
    currentShowcaseIDs() {
      return this.$store.state.dash.viewData.currentShowcasedIDs
    },
    noReviews () {
      return this.$store.getters['dash/externalPlatforms'][this.platform].noReviews
    },
    operationInProgress() {
      return this.$store.state.dash.showcaseOperationInProgress
    }
  },
  components: {
    StarRating,
    'vue-load-image': VueLoadImage,
    Showcase
  },
  methods: {
    getMore() {
      this.$emit('load-reviews', this.platform)
      return
    },
    /*actionShowcaseReview (pf, i, reviewDocID) {
      this.$store.commit('dash/SHOWCASE_OPERATION_IN_PROGRESS', true)
      this.$store.dispatch('dash/TOGGLE_MARK_SHOWCASE', { platform: pf , i, reviewDocID }).then((res) => {
        //noconsoleconsole.log('success')
        this.$store.commit('dash/SHOWCASE_OPERATION_IN_PROGRESS', false)
        this.$vs.notify({
          title: res.unmarkIt ? 'Remove showcase review'  : 'Showcase review',
          text: res.unmarkIt ? 'Removed review from showcase'  : 'Added review for showcase',
          color:'success',
          time: 4000,
          iconPack: 'feather',
          icon:'icon-check'})
      }).catch((e) => {
        //noconsoleconsole.log('failure')
        this.$vs.notify({
          title:'Showcase review',
          time: 10000,
          text:'Oops! Something went wrong, and we couldn\'t add your review for showcase. Please try again, or please reach out for support if it happens again.',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
        this.$store.commit('dash/SHOWCASE_OPERATION_IN_PROGRESS', false)
        this.$store.commit('dash/TOGGLE_MARK_REVIEW_SHOWCASE', {
          platform: pf,
          i: i,
          docID: reviewDocID
        })
      })
    },*/
    actionShowcaseReview (pf, i, reviewDocID, tag, intent, currentTags) {
      
      this.$store.commit('dash/SHOWCASE_OPERATION_IN_PROGRESS', true)
      
      this.$store.dispatch('dash/TOGGLE_MARK_SHOWCASE', { platform: pf , i, reviewDocID, intent, tag, currentTags }).then((res) => {
        //noconsoleconsole.log('success')
        this.$store.commit('dash/SHOWCASE_OPERATION_IN_PROGRESS', false)
        this.$vs.notify({
          title: res.unmarkIt ? 'Remove showcase review'  : 'Showcase review',
          text: res.unmarkIt ? 'Removed review from showcase'  : 'Added review for showcase',
          color:'success',
          time: 4000,
          iconPack: 'feather',
          icon:'icon-check'
        })

      }).catch((e) => {
        //noconsoleconsole.log('failure')
        console.log(e)

        this.$vs.notify({
          title:'Showcase review',
          time: 10000,
          text:'Oops! Something went wrong, and we couldn\'t add your review to showcase. Please try again, or please reach out for support if it happens again.',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-alert-circle'
        })

        this.$store.commit('dash/SHOWCASE_OPERATION_IN_PROGRESS', false)
        
        this.$store.commit('dash/MARK_SHOWCASE_ITEM', {
          jFI: i,
          rvwOrSnID: reviewDocID,
          type: pf,
          tag,
          intent: !intent
        })       

      })

    },
    toggleShowcaseReview (pf, i, reviewDocID, tag, intent, currentTags) {

      
      //tell local store that item is showcased
      this.$store.commit('dash/MARK_SHOWCASE_ITEM', {
        jFI: i,
        rvwOrSnID: reviewDocID,
        type: 'review',
        tag,
        intent
      })

      const check = (pf, i, reviewDocID, tag, intent, currentTags) => {
        if (this.operationInProgress) {
          //noconsoleconsole.log('op in progress')
          setTimeout(() => {
            check(pf, i, reviewDocID, tag, intent, currentTags)
          }, 100)
        } else {
          //noconsoleconsole.log('op not in progress, actioning')
          this.actionShowcaseReview (pf, i, reviewDocID, tag, intent, currentTags)
        }
      }

      check(pf, i, reviewDocID, tag, intent, currentTags)


      /*

      this.$store.commit('dash/TOGGLE_MARK_REVIEW_SHOWCASE', {
        platform: pf,
        i,
        docID: reviewDocID
      })

      let check = (pf, i, reviewDocID) => {
        if (this.operationInProgress) {
          //noconsoleconsole.log('op in progress')
          setTimeout(() => {
            check(pf, i, reviewDocID)
          }, 500)
        } else {
          //noconsoleconsole.log('op not in progress, actioning')
          this.actionShowcaseReview (pf, i, reviewDocID)
        }
      }

      check(pf, i, reviewDocID)

      */


    }
  },
  beforeDestroy () {
    this.$store.commit('dash/SHOWCASE_OPERATION_IN_PROGRESS', false)
  }
}

</script>

<style lang="scss">

.vue-star-rating-rating-text{
  font-weight: 500;
  color: #4c4c4c;
  font-size: 1.6rem;
  position: relative;
  bottom: 0.1rem;
}

  .profiledown {
    position: relative;
    top: 0.2rem;
    margin-right: 0.4rem;
  }


.vs-con-loading__container {
  position: static;
}

.vue-star-rating-rating-text{
  font-weight: 600;
  color: #4c4c4c;
  font-size: 1rem;
}

</style>
